import Entity from "../../../class/abstract/Entity"
import moment from "moment";

class Account extends Entity {
    fullname = ""
    firstname = ""
    lastname = ""
    email = ""
    bigBisoux = 0
    companyRules = ""
    rules = ""
    status = 200
    validity = 0
    onlyHivy = 0

    constructor(datas = {}) {
        super(datas)
        this.setAttributes(datas)
    }

    setAttributes(datas) {
        let keys = Object.keys(this)
        let key = ""

        for(let i in keys) {
            key = keys[i]

            if (datas[key] !== undefined) {
                if (["firstname", "lastname"].includes(key))
                    Reflect.set(this, key, this.capitalizeFLetter(datas[key].toLocaleLowerCase()))
                else if (["email"].includes(key))
                    Reflect.set(this, key, datas[key].toLocaleLowerCase())
                else
                    Reflect.set(this, key, datas[key])
            }
        }

        let firstname = this.firstname !== null ? this.firstname : ""
        let lastname = this.lastname !== null ? this.lastname : ""

        Reflect.set(this, "fullname", (this.capitalizeFLetter(firstname.toLocaleLowerCase()) + " " + lastname.toLocaleUpperCase()).trim())
    }
    capitalizeFLetter(str) {
        return str.length > 0 ? str[0].toUpperCase() + str.slice(1) : "";
    }

    static buildStrRules(rules) {
        let strRules = "";

        if (rules.length === 0)
            return "aucun"

        if (rules.includes("|")) {
            let explodeRules = rules.split("|")

            for (let i in explodeRules) {
                if (strRules.length > 0) strRules += ", "
                strRules += this.ruleName(explodeRules[i].trim())
            }
        }
        else
            strRules = this.ruleName(rules)

        return strRules
    }
    static ruleName = rule => {
        switch (rule) {
            case "SKYTECH": return "[TECHNICIEN] Administrateur"
            case "ADMIN": return "Administrateur"
            case "ACCOUNTANT": return "Comptable"
            case "ANALYST": return "Analyste"
            case "TECH": return "Technicien"
            case "PRODUCTS": return "Catalogue"
            case "MANAGER": return "Manager"
            default: return ""
        }
    }
    static buildState(status, onlyHivy, created_at, validity) {
        moment.updateLocale('fr', {
            months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
            monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
            monthsParseExact : true,
            weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
            weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
            weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
            weekdaysParseExact : true,
            longDateFormat : {
                LT : 'HH:mm',
                LTS : 'HH:mm:ss',
                L : 'DD/MM/YYYY',
                LL : 'D MMMM YYYY',
                LLL : 'D MMMM YYYY HH:mm',
                LLLL : 'dddd D MMMM YYYY HH:mm'
            },
            calendar : {
                sameDay : '[Aujourd’hui à] LT',
                nextDay : '[Demain à] LT',
                nextWeek : 'dddd [à] LT',
                lastDay : '[Hier à] LT',
                lastWeek : 'dddd [dernier à] LT',
                sameElse : 'L'
            },
            relativeTime : {
                future : '%s',
                past : '%s',
                s : 'quelques secondes',
                m : 'une minute',
                mm : '%d minutes',
                h : 'une heure',
                hh : '%d heures',
                d : 'un jour',
                dd : '%d jours',
                M : 'un mois',
                MM : '%d mois',
                y : 'un an',
                yy : '%d ans'
            },
            dayOfMonthOrdinalParse : /\d{1,2}(er|e)/,
            ordinal : function (number) {
                return number + (number === 1 ? 'er' : 'e');
            },
            meridiemParse : /PD|MD/,
            isPM : function (input) {
                return input.charAt(0) === 'M';
            },
            // In case the meridiem units are not separated around 12, then implement
            // this function (look at locale/id.js for an example).
            // meridiemHour : function (hour, meridiem) {
            //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
            // },
            meridiem : function (hours, minutes, isLower) {
                return hours < 12 ? 'PD' : 'MD';
            },
            week : {
                dow : 1, // Monday is the first day of the week.
                doy : 4  // Used to determine first week of the year.
            }
        })
        let strState = onlyHivy === 1 ? "Temporaire : " : ""

        if (status === 200) {
            if (validity !== null && validity > 0)
                strState += moment(created_at).add(validity, 'minutes').fromNow()
            else
                strState += "Activé"
        }
        else {
            switch (status) {
                case 471:
                    strState += "Suspendu"
                    break
                default:
                    strState += "Désactivé"
                    break
            }
        }

        return strState
    }
}

export default Account
